import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCard, MatCardActions, MatCardContent } from '@angular/material/card';
import { MatError } from '@angular/material/form-field';
import { firstValueFrom } from 'rxjs';

import { UserService } from '../../../user';
import { CardHeaderComponent } from '../../card/header/card-header.component';
import { ButtonComponent, InputComponent } from '../../form';

@Component({
  selector: 'dmb-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss', '../modal.scss'],
  imports: [
    MatCard,
    ReactiveFormsModule,
    CardHeaderComponent,
    MatCardContent,
    InputComponent,
    MatError,
    MatCardActions,
    ButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent {
  private dialogRef = inject(DialogRef);
  private userService = inject(UserService);

  userInput = new FormControl('', { nonNullable: true, validators: Validators.required });

  sendingError = signal(false);
  showForm = signal(true);
  loading = signal(false);

  async resetPassword() {
    if (this.userInput.invalid) return;
    try {
      this.loading.set(true);
      await firstValueFrom(this.userService.requestPasswordReset(this.userInput.value));
      this.showForm.set(false);
    } catch (_) {
      this.sendingError.set(true);
    } finally {
      this.loading.set(false);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
